import React, { useEffect, useState } from "react"
import API from "../../api/axios"
import { FormGroup, Label, Input } from "reactstrap"

function Doctordropdown({
  selectedDoctorId,
  onselect,
  onDoctorAvailabilityChange,
}) {
  const [doctor, setDoctor] = useState([])

  const fetchDoctor = async () => {
    try {
      const token = localStorage.getItem("authToken")

      const res = await API.get(
        "/doctorAvailibility/active-doctors",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      const doctorList = res.data || []
      setDoctor(doctorList)

      if (doctorList.length > 0) {
        const firstDoctorId = doctorList[0].id
        onselect(firstDoctorId)
        fetchDoctorAvailability(firstDoctorId)
      }
    } catch (error) {
      console.error("Error loading doctor", error)
    }
  }

  const fetchDoctorAvailability = async doctorId => {
    try {
      if (!doctorId) {
        onDoctorAvailabilityChange([])
        return
      }

      const token = localStorage.getItem("authToken")
      const res = await API.get(
        `/doctorAvailibility/${doctorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      const availability = res.data?.data?.availability
      console.log("doctor details....", availability)
      onDoctorAvailabilityChange(availability)
    } catch (error) {
      console.error("Error fetching doctor availability", error)
    }
  }

  //  Fetch doctor list on component mount
  useEffect(() => {
    fetchDoctor()
  }, [])

  // Fetch availability for the initially selected doctor
  useEffect(() => {
    if (selectedDoctorId) {
      fetchDoctorAvailability(selectedDoctorId)
    }
  }, [selectedDoctorId, doctor])

  const handleDoctorChange = async e => {
    const selectedId = e.target.value
    onselect(selectedId)
    await fetchDoctorAvailability(selectedId)
  }

  return (
    <div className="p-3">
      <FormGroup>
        <Label for="doctorSelect">Select Doctor</Label>
        <Input
          type="select"
          id="doctorSelect"
          value={selectedDoctorId}
          onChange={handleDoctorChange}
        >
          {doctor.map(doc => (
            <option key={doc.id} value={doc.id}>
              {doc.fname} {doc.lname}
            </option>
          ))}
        </Input>
      </FormGroup>
    </div>
  )
}

export default Doctordropdown
